export default "__VITE_ASSET__Ceawz44X__"